import React from "react";
import AppDownloadSection from "../components/AppDownloadSection";
import CtaSection from "../components/CtaSection";
import { Link } from "react-router-dom";

const Service = () => {
  const serviceCard = [
    {
      id: 1,
      title: "Last-mile logistics",
    //   description:
    //     "With a 99.9% on-time delivery rate, Pegiora has built a reputation for speed and precision. Whether handling medical specimens, urgent documents, or high-value shipments, we guarantee that every package arrives on schedule and in perfect condition.",
      link: "#",
      image: "/image/qimg1.jpg",
    },
    {
      id: 2,
      title: "Outbound logistics",
    //   description:
    //     "We integrated real-time tracking into our logistics network, allowing customers to monitor their shipments with accuracy. From medical samples to e-commerce orders, our tracking system ensures visibility, efficiency, and security at every ste",
      link: "#",
      image: "/image/qimg2.jpg",
    },
    {
      id: 3,
      title: "Inbound logistics",
    //   description:
    //     "Extending our global footprint to over 50 countries, we're connecting businesses worldwide, fostering Through strategic partnerships and enhanced logistics networks, Pegiora expanded to 50+ countries, connecting businesses and ensuring seamless cross-border trade. Our 24/7 operations make international shipping fast, reliable, and hassle-free.growth, and facilitating seamless cross-border trade",
      link: "#",
      image: "/image/qimg3.jpg",
    },
    {
      id: 4,
      title: "Integrated Logistics",
    //   description:
    //     "Cutting carbon emissions by 30%, we prioritize sustainability, implementing eco-friendly practices to protect the environment while delivering exceptional service.",
      link: "#",
      image: "/image/qimg4.jpg",
    },
  ];

  const Freight = [
    {
      id: 1,
      heading: "Heavy Freight Hauling",
      paragraph:
        "We’re equipped with the resources to transport all your overweight shipments, including heavy equipment and cumbersome machinery. Whether expedited or standard shipping, our professional logistics team will facilitate appropriate and safe routing, obtain suitable permits, and provide streamlining guidance. We’ll always supply you with specialized transport that's reliable, efficient, and safe.",
      icon: "/image/service-wedo-icon1.svg",
    },
    {
      id: 2,
      heading: "FTL Freight Shipping",
      paragraph:
        "Do you need to transport a full truckload of freight? Whether it’s short or long-haul, our experts will arrange a suitable tractor-trailer to get your time-sensitive freight to wherever it needs to be. Our premium fleet is ready to transport your large freight loads across the nation.",
      icon: "/image/service-wedo-icon2.svg",
    },
    {
      id: 3,
      heading: "Oversized Freight",
      paragraph:
        "Our flatbed trailers and open-deck trucks carry both legal and over-dimensional loads. As full-service flatbed step deck and RGN carrier experts, our over-dimensional department will ensure the secure delivery of your freight load when it exceeds defined limitations. We guarantee your freight is transported along the safest routes with appropriate permits by the most qualified drivers.",
      icon: "/image/service-wedo-icon3.svg",
    },
    {
      id: 4,
      heading: "Hazmat Shipping",
      paragraph:
        "If not handled properly, shipping hazardous materials can turn out a disastrous experience. At Cowtown Logistics Freight Management, we have been shipping hazmat for years, so we ensure the complete safety of your shipments.",
      icon: "/image/service-wedo-icon4.svg",
    },
    {
      id: 5,
      heading: "Temp-Controlled Freight",
      paragraph:
        "Cowtown Logistics Freight Management offers temperature-controlled delivery for delicate and sensitive items that need to be kept safe in their original state. Our wide variety of fleet specifications with cooling units, insulation, and specified configurations ensures the maximum protection of more sensitive freight. Rest assured, we can safely transport any product that needs temperature-controlled delivery.",
      icon: "/image/service-wedo-icon5.svg",
    },
    {
      id: 6,
      heading: "Power-Only",
      paragraph:
        "At Cowtown Logistics Freight Management, we offer power-only truck hauling for short-haul, long-haul, mission-critical, and standard freight trucking needs. Our professional drivers do dedicated runs to maintain your supply chain. We believe moving trailers should be easy and affordable.",
      icon: "/image/service-wedo-icon6.svg",
    },
  ];

  return (
    <>
      <section className="service-banner-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12">
              <div className="left-serv-bsec">
                <h2>Cowtown Logistics: Built for Freight. Trusted by Titans.  </h2>
                <p>
                  We move freight like we mean it. Cowtown Logistics is your coast-to-coast partner for ground transportation and domestic freight logistics. We don't guess -- we plan. We don't delay -- we deliver. With 20+ years of real trucking experience, we make sure your freight shows up where it should, when it should, and how it should. Work with us once, and you'll see why our customers stick around. 
                </p>
                <Link to="/Qutaionsform"  className="start-btn-service">
                  Get A Quate <span className="ms-2">→</span>
                </Link>
              </div>
            </div>

            {/* Right Image Section */}
            <div className="col-lg-4 col-md-5 col-sm-12">
              <div className="right-serv-bse">
                <img
                  src="/image/qimg5.jpg"
                  alt="Delivery Image"
                />
              </div>
            </div>

            {/* <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row mt-4">
                <div className="col-lg-4 col-md-6 col-sm-12 serv-bnr-inrsubcard mb-4">
                  <div className="stats-serv-card scgreen">
                    <div className="scds-card">
                      <h3>120K</h3>
                      <h5>Safety Shipped</h5>
                    </div>
                    <p>Ensuring safe and timely deliveries with utmost care.</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12 serv-bnr-inrsubcard mb-4">
                  <div className="stats-serv-card scwhite">
                    <div className="scds-card">
                      <h3>24/7</h3>
                      <h5>Delivery Services</h5>
                    </div>
                    <p>No time constraints, we operate round the clock.</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="stats-serv-card scblue">
                    <div className="scds-card">
                      <h3>12K</h3>
                      <h5>Users trusting us</h5>
                    </div>
                    <p>
                      Safe handling of all shipments, including medical
                      supplies.
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* section2-------------------------- */}
      <section className="service-exp">
        <div className="container">
          <div className="row">
            <div className="text-center mb-5">
              <div className="service-exp-head">
                <h3>Your Third-Party Logistics Provider </h3>
                <p>
                  Experience peace of mind withCowtown Logistics Freight Management - one of the most reliable and experienced third-party logistics providers in the Dallas-Fort Worth area. We're committed to providing you with top-notch logistics services and logistics management, optimizing your supply chain processes, and ensuring that your logistics requirements are handled proficiently. In addition, our third-party logistics company offers you strategic advantages in today's competitive market that result in cost savings.
                </p>
              </div>
            </div>

            <div className="" style={{display:"grid" , gridTemplateColumns:"1fr 1fr"}}>
              {serviceCard.map((servCard, index) => (
                <div key={servCard.id} className="servive-explist">
                  <h3>{servCard.title}</h3>
                  <img src={servCard.image} alt="On-Time Delivery" />
                  <p>{servCard.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* // section 3------------------- */}
      <section className="service-wedo">
        <div className="container">
          <div className="text-center mb-5">
            <h2>We Provide Freight Trucking Solutions</h2>
            <p>
              Explore a world of efficient, reliable, and cost-effective freight trucking solutions with Cowtown Logistics Freight Management. Our team is dedicated to making your freight transportation hassle-free and seamless, allowing you to focus on your core business activities.
            </p>
          </div>

          <div className="row">
            {Freight.map((ele, index) => (
              <div
                key={ele.id}
                className="col-lg-4 col-md-6 col-sm-12 mb-5"
              >
                <div className="serv-wedo-card">
                  {/* <div className="serv-wedo-card-icon">
                    <img src={ele.icon} alt={ele.heading} />
                  </div> */}
                  <h3>{ele.heading}</h3>
                  <p>{ele.paragraph}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section>
        
                <Link to="/service"  className="start-btn-service">
                  Services <span className="ms-2">→</span>
                </Link>

                <Link to="/Qutaionsform"  className="start-btn-service">
                  Get A Quate <span className="ms-2">→</span>
                </Link>
      </section> */}
    </>
  );
};

export default Service;
